module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_svenljunga-ff33b7cbe441bf6f3d156c312f804f91.png";